


// src/components/sections/GallerySection.js
import React, { useState } from 'react';
import '../../../styles/sections.css';

const GallerySection = ({ content }) => {
  const { images = [] } = content;
  const [selectedImage, setSelectedImage] = useState(null);

  if (!images.length) return null;

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="py-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {images.map((image, index) => (
          <div 
            key={index} 
            className="cursor-pointer hover:opacity-90 transition-opacity"
            onClick={() => openModal(image)}
          >
            <img 
              src={image.url} 
              alt={image.alt || `Gallery image ${index + 1}`}
              className="w-full h-64 object-cover rounded"
            />
            {image.caption && (
              <p className="text-sm text-gray-600 mt-2">{image.caption}</p>
            )}
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50" onClick={closeModal}>
          <div className="max-w-4xl max-h-screen p-4">
            <img 
              src={selectedImage.url} 
              alt={selectedImage.alt || 'Gallery image'} 
              className="max-w-full max-h-[80vh] object-contain"
            />
            {selectedImage.caption && (
              <p className="text-white text-center mt-4">{selectedImage.caption}</p>
            )}
          </div>
          <button 
            onClick={closeModal}
            className="absolute top-4 right-4 text-white text-3xl hover:text-gray-300"
          >
            &times;
          </button>
        </div>
      )}
    </div>
  );
};

export default GallerySection;
